import React from 'react';

function RedArrowDown(props: object) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="6"
        cy="6"
        r="6"
        transform="rotate(-180 6 6)"
        fill="#FF4646"
        fillOpacity="0.3"
      />
      <path
        d="M6.6 2C6.6 1.66863 6.33137 1.4 6 1.4C5.66863 1.4 5.4 1.66863 5.4 2L6.6 2ZM5.57574 9.7576C5.81005 9.99191 6.18995 9.99191 6.42426 9.7576L10.2426 5.93922C10.477 5.70491 10.477 5.32501 10.2426 5.09069C10.0083 4.85638 9.62843 4.85638 9.39411 5.09069L6 8.48481L2.60589 5.09069C2.37157 4.85638 1.99167 4.85638 1.75736 5.09069C1.52304 5.32501 1.52304 5.70491 1.75736 5.93922L5.57574 9.7576ZM5.4 2L5.4 9.33333L6.6 9.33333L6.6 2L5.4 2Z"
        fill="#FF4646"
      />
    </svg>
  );
}

export default RedArrowDown;
